import { Link, useLocation } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

import { useUser } from '../store/UserProvider';

import styleClasses from './css/Header.module.scss';
import { useEffect, useState } from 'react';

const HeaderLinkItem = ({ mobileMenuItemsClass, clickOnMobile }) => {
  const { user } = useUser();

  let location        = useLocation();
  let currentLocation = location.pathname;
  let locationArray   = currentLocation.split('/');
  let firstValue      = locationArray.length > 1 ? locationArray[1] : '/';

  return (
    <nav className={`${ styleClasses.mainNavigation} ${ mobileMenuItemsClass }`}>
      <ul>
        <li>
          <Link to="/" className={ currentLocation === '/' ? styleClasses.active : '' } onClick={ clickOnMobile }>HOME</Link>
        </li>
        <li>
          <Link to="/musicard" className={ firstValue === 'musicard' ? styleClasses.active : '' } onClick={ clickOnMobile }>MUSICARD</Link>
        </li>
        {/*<li>
          <Link to="/about-us" className={ firstValue === 'about-us' ? styleClasses.active : '' } onClick={ clickOnMobile }>ABOUT US</Link>
        </li>*/}
        {
          user
          ? 
          <li><Link to="/my-page" className={ firstValue === 'my-page' ? styleClasses.active : '' } onClick={ clickOnMobile }>MY PAGE</Link></li>
          :
          <li><Link to="/login" className={ firstValue === 'login' ? styleClasses.active : '' } onClick={ clickOnMobile }>LOGIN</Link></li>              
        }
      </ul>
    </nav>
  );
}

const Header = () => {
  let location  = useLocation();
  let { user }  = useUser();

  const [firstValue, setFirstValue]   = useState('');
  const [secondValue, setSecondValue] = useState('');
  const [userTab, setUserTab]         = useState(false);
  
  useEffect(() => {
    if (user?.userID) {
      let currentLocation = location.pathname;
      let locationArray   = currentLocation.split('/');
      setFirstValue(locationArray.length > 2 ? locationArray[1] : '/');
      setSecondValue(locationArray.length > 2 ? locationArray[2] : null);

      const getUserInfo = async () => {
        const userRef = doc(db, "users", user.userID);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          let musicards = [];
          
          const getMusicards = userData.musicard ? Object.values(userData.musicard) : [];
          getMusicards.forEach((value) => {
            musicards.push(value);
          });
          
          if (getMusicards.includes(secondValue)) {
            setUserTab(true);
          } else {
            setUserTab(false);
          }
        }
      }

      getUserInfo();
    } else {
      setUserTab(false);
    }
  }, [location.pathname, secondValue, user?.userID]);

  return (
    <header className={ styleClasses.header }>
      {
        userTab
        &&
        <div className={ styleClasses.fixedTab }>
          <Link to='/my-page/portfolio' state={{ musicardID: secondValue }} className="commonIcon">
            <i className='plusWhite w20'></i>
            포트폴리오 만들기
          </Link>
          <Link to={`/my-page/${ firstValue }/${ secondValue }`} className="commonIcon">
            <i className='pencilWhite w20'></i>
            뮤지카드 편집
          </Link>
        </div>
      }
      <div className={ styleClasses.inner }>
        <div className={ styleClasses.container }>
          <div className={ styleClasses.logo }>
            <Link to='/'>
              <img src={`${process.env.PUBLIC_URL}/assets/images/logo.webp`} alt="MusiCards" />
              <h1>Musizic</h1>
            </Link>
          </div>
          <HeaderLinkItem />
        </div>
      </div>
    </header>
  );
};

export default Header;
